'use client';
import React, { useEffect, useState } from 'react';
import '../Index.css';
import { Box, Paper, Typography, SortDirection } from '@mui/material';
import AddButtonComponent from '../../../../components/form/AddButtonComponent';
import Constants from '../../../../utils/constants';
import HttpService from '../../../../services/HttpService';
import { useStore } from '../../../../utils/store';
import { useNavigate } from 'react-router-dom';
import CustomPaginationActionsTable from '../../../../components/TablePagination';
import SwitchComponent from '../../../../components/SwitchComponent';
import { useSearch } from '../../../../components/searchContext';
import AlertMessageComponent from '../../../../components/AlertMessageComponent';
import { useAlert } from '../../../../components/alertContext';

const StandardTerms: React.FC = () => {
  const { searchQuery } = useSearch();
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const [orderBy, setOrderBy] = useState<any>('termText');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  // Columns definition for the table
  const columns: any[] = [
    { field: 'termText', headerName: 'Text' },
    {
      field: 'status',
      headerName: 'Active',
      disableSort: true,
      renderCell: (value: any) => (
        <SwitchComponent
          checked={value === '1'}
          value={value}
          size="small"
          color="success"
          inputProps={{ 'aria-label': 'controlled' }}
          handleInputChange={() => console.log('clickstatus')}
          name={'statuseterm'}
        />
      ),
    },
    {
      field: 'updated',
      headerName: 'Last Updated',
      valueGetter: (value: any) =>
        new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
    },
    {
      field: 'created',
      headerName: 'Date Created',
      valueGetter: (value: any) =>
        new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
    },
  ];

  // State variables
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<any[]>([]);
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });

  // Fetch terms list
  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.termsURL,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('termText');
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchQuery, paginate]);
  // Handle status toggle
  const handleStatus = async (row: any) => {
    const newStatus = row.status === '1' ? '0' : '1';
    try {
      const response = await HttpService.patch(
        Constants.apiURL + Constants.termsURL,
        { status: newStatus, id: row.id },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchData();
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  // Clear form and reset state

  const handlePagination = (paginationData: any) => setPaginate(paginationData);

  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">
                  Standard Terms & Conditions
                </Typography>
                <AddButtonComponent
                  onClick={() => {
                    navigate('/data-management/standard-terms-conditions/Add');
                    //setDialogOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Add New"
                />
              </Box>
              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={totalRecords}
                handlePagination={handlePagination}
                handleRowClick={(row) =>
                  navigate(
                    `/data-management/standard-terms-conditions/${row.id}`
                  )
                }
                paginationModel={{
                  page: paginate.offset,
                  pageSize: paginate.limit,
                }}
                handleStatus={handleStatus}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
              />
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default StandardTerms;
